module.exports = __webpack_public_path__ + "img/__icon_SWAPBODY.f58f8d73.svg";